const ENV = {
  API_HOST: process.env.REACT_APP_API_HOST,
};

export default ENV;
